module.exports = __webpack_public_path__ + "img/robot_progress.5cfb6e26.png";